module.exports = __webpack_public_path__ + "img/supplierEntryGuidelines_04.85f73698.png";